import React, { useEffect } from 'react';
import { Button } from 'reactstrap';
import RenderIcon from '../commons/RenderIcon';
import { startWorkflow } from '../../actions/workflows';

const _Button = (props) => {
    const { layoutItem: { itemProperties: { workflowNextButtonConfig } }, classProperty, type, validations, value, label, isReadOne, nextState, workflow: { displayMode }, customIcons, disableSaveAndNext, ...rest } = props;
    const isLoading = nextState && nextState.isLoading ? true : false;
    const uniqueCode = workflowNextButtonConfig && workflowNextButtonConfig.item && workflowNextButtonConfig.item.value;
    const endWorkflow = workflowNextButtonConfig && workflowNextButtonConfig.endWorkflow;
    const refreshPage = workflowNextButtonConfig && workflowNextButtonConfig.refreshPage;
    const color = workflowNextButtonConfig && workflowNextButtonConfig.buttonStyle ? workflowNextButtonConfig.buttonStyle : 'primary';
    const outline = workflowNextButtonConfig && workflowNextButtonConfig.isOutline;
    const iconConfig = workflowNextButtonConfig && workflowNextButtonConfig.cssClass ? {
        cssClass: workflowNextButtonConfig.cssClass
    } : null;
    useEffect(() => {
        return () => {
            window.saveClicked = false;
        }
    }, [])
    return (
        <div>
            <Button data-html2canvas-ignore='true' name='uniqueCode' onClick={uniqueCode ? () => {
                window.saveClicked = true;
                props.jumptoSubmit({ jumpto: uniqueCode })
            } : props.onHandleSubmit(values => {
                window.saveClicked = true;
                if (displayMode != 'MODAL') {
                    window && window.scrollTo({ top: 0, behavior: 'smooth' })
                }
                let payload = values;
                if (uniqueCode) {
                    payload = values.set('jumpto', uniqueCode)
                } else if (endWorkflow) {
                    payload = values.set('endWorkflow', endWorkflow);
                    if (refreshPage) {
                        payload = values.set('refreshPage', refreshPage);
                    }
                } else if (refreshPage) {
                    payload = values.set('refreshPage', refreshPage);

                    // payload = values.set('refreshPage', refreshPage);
                }
                props.onSubmit(payload);
            })}
                disabled={props.disableLayoutItem || isLoading || disableSaveAndNext}
                block
                color={color}
                outline={outline}
            >
                {
                    iconConfig && !isLoading ? <RenderIcon customIcons={customIcons} config={iconConfig} /> : null
                }
                {!isLoading ? label.text : 'Please wait...'}
            </Button>
        </div>
    );
}

export default _Button;
